export default __webpack_public_path__ + "static/media/Danielle Penman.d8f64d95.jpg";